import get from 'lodash/get';
import isArray from 'lodash/isArray';
import moment from 'moment';

import DatePicker from '~/components/DatePicker';
import { SearchContext } from '~/components/SearchBuilder/utils/searchUtils';
import ClearbitSelect from '~/components/Select';
import TextField from '~/components/TextField';

import valueDateStyles from './styles';

const withinOptions = [
  { value: 'day', label: 'days' },
  { value: 'week', label: 'weeks' },
  { value: 'month', label: 'months' },
  { value: 'year', label: 'years' },
];

// TODO: Figure out how to calculate number/increment values here
// based on how the back-end will expect these values
const getInterval = (value) => get(value, 'interval');
const getAmount = (value) => get(value, 'amount');
const calculateValue = (amount, interval) => {
  return {
    interval,
    amount: parseInt(amount),
  };
};

class ValueDate extends React.Component {
  render() {
    const { classes = {}, onChange, value, comparator } = this.props;
    const { disabled } = this.context;

    let startDate, endDate;

    if (value) {
      const startValue = isArray(value) ? value[0] : value;
      const endValue = isArray(value) ? value[1] : value;

      startDate = moment(startValue || undefined)
        .utc()
        .format('YYYY-MM-DD');
      endDate = moment(endValue || undefined)
        .utc()
        .format('YYYY-MM-DD');
    }

    const interval = getInterval(value);
    const amount = getAmount(value);

    switch (comparator) {
      case 'date_between':
      case 'date_not_between':
        return (
          <div className={classnames(classes.value, classes.datePickers)}>
            <DatePicker
              disabled={disabled}
              variant="outlined"
              defaultValue={startDate}
              defaultStartDate={startDate}
              onChange={(startDate) => {
                onChange([startDate, endDate]);
              }}
            />
            <div className={classes.and}>and</div>
            <DatePicker
              disabled={disabled}
              variant="outlined"
              defaultValue={endDate}
              defaultStartDate={endDate}
              onChange={(endDate) => {
                onChange([startDate, endDate]);
              }}
            />
          </div>
        );
      case 'date_in_last':
      case 'date_in_next':
        return (
          <div className={classnames(classes.value, classes.withinContainer)}>
            <TextField
              disabled={disabled}
              type="number"
              value={amount}
              placeholder="1"
              inputProps={{ min: '1', step: '1' }}
              FormControlProps={{
                classes: {
                  root: classes.withinText,
                  input: classes.largeInput,
                },
              }}
              onChange={(event) => {
                const amount = event.target.value;
                const value = calculateValue(amount, interval);
                onChange(value);
              }}
            />
            <ClearbitSelect
              disabled={disabled}
              className={classes.withinSelect}
              getOptionValue={(o) => o.value}
              getOptionLabel={(o) => o.label}
              value={withinOptions.find(
                (option) => option.value === getInterval(value),
              )}
              options={withinOptions}
              onChange={(option) => {
                const interval = option.value;
                const value = calculateValue(amount, interval);
                onChange(value);
              }}
            />
          </div>
        );
      default:
        return (
          <DatePicker
            disabled={disabled}
            key={value}
            classes={{ inputRoot: classes.value }}
            variant="outlined"
            defaultValue={isArray(value) ? value[0] : value}
            defaultStartDate={startDate}
            onChange={(value) => onChange(value)}
          />
        );
    }
  }
}

ValueDate.contextType = SearchContext;

ValueDate.propTypes = {
  classes: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  comparator: PropTypes.string,
};

export default withStyles(valueDateStyles)(ValueDate);
